import React from 'react'
import PropTypes from 'prop-types'

import TextLabelLoader from '~/components/TextLabelLoader'
import EmptyContent from '~/components/EmptyContent/EmptyContent'
import { EmptyNotesIcon } from '~/components/Icons'

function CustomerNotes ({ notes }) {
  return (
    <>
      {notes
        ? (
          <TextLabelLoader label="Notes">
            {notes}
          </TextLabelLoader>
        )
        : (
          <EmptyContent
            icon={<EmptyNotesIcon />}
            text="Customer note not found."
          />
        )}
    </>

  )
}

CustomerNotes.propTypes = {
  notes: PropTypes.string
}

export default CustomerNotes
